import { render, staticRenderFns } from "./testdata.vue?vue&type=template&id=5b5d97e4"
import script from "./testdata.vue?vue&type=script&lang=js"
export * from "./testdata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports